import CrmCoreTeam from '@/types/serializers/CrmCoreTeam'
import { TeamNode } from './TeamNode'

export type TeamTreeNode = CrmCoreTeam & { children: TeamTreeNode[] }

interface TeamTreeProps {
  teams: TeamTreeNode[]
  onEdit: (team: TeamTreeNode) => void
  onCreate: (parentId?: number) => void
}

export function TeamTree({ teams, onEdit, onCreate }: TeamTreeProps) {
  if (teams.length === 0) {
    return (
      <div className="py-12 text-center text-muted-foreground">
        No teams yet. Create your first team to get started.
      </div>
    )
  }

  return (
    <div className="space-y-0.5">
      {teams.map((team) => (
        <TeamNode
          key={team.id}
          team={team}
          depth={0}
          allTeams={teams}
          onEdit={onEdit}
          onCreate={onCreate}
        />
      ))}
    </div>
  )
}
